export enum OpportunityDocumentationType {
  DEFAULT = 'DEFAULT',
  TEMPLATE = 'TEMPLATE',
}

export type INewOpportunityOperationDocumentationForm = {
  documentationType: OpportunityDocumentationType;
  templateFile?: string;
};
